import React from 'react';
import PropTypes from 'prop-types';
// import Dropzone from 'react-dropzone';
import Datetime from 'react-datetime';
import Moment from 'moment';
import { Popup } from 'components/Popup/popup';
import { CheckBoxSingle } from 'components/checkboxes/check-box-single';
import { formatTimezoneDateTime } from 'helper/unit-helper';
import { AppSettings } from '../../constants';
import SignatureCanvas from 'react-signature-canvas';
import * as CommonActionType from 'Common/constants';
import * as RFSActionType from '../../Request-Services/constants';
import { connect } from 'react-redux';
class SignoffPopup extends React.Component {
  static propTypes = {
    onSaveSignoffPopup: PropTypes.func,
    onCancelSignoffPopup: PropTypes.func,
    isSignoffFromOpen: PropTypes.bool,
    onUploadFileToS3: PropTypes.func,
    rfsId: PropTypes.string,
    workOrderId: PropTypes.string,
    dispatch: PropTypes.func,
    RFSEndpoint: PropTypes.object,
    checkHomeownerWO: PropTypes.boolean,
    onCheckHomeownerSignatureWO: PropTypes.func,
    onCheckUploadFile: PropTypes.func,
    onResetCheckUploadFile: PropTypes.func,
    UploadSuccess: PropTypes.bool,
    isAccordion: PropTypes.bool
  };

  constructor(props) {
    super(props);

    this.state = {
      lastResolvedDate: Moment().format('MM/DD/YYYY'),
      lastClosedDate: Moment().format('MM/DD/YYYY'),
      isChecked: false,
      accepted: null,
      rejected: [],
      error: {
        lastResolvedDate: null,
        lastClosedDate: null
      },
      homeownerSignature: null,
      homeownerSignatureUrl: null,
      builderProfile: null,
      signatureStatus: this.props.UploadSuccess
    };
  }

  componentDidMount() {
    if (AppSettings.clientTypeValue === 'Homeowner') {
      this.fetchRFS();
      this.props.onCheckHomeownerSignatureWO();
    }

    this.props.onCheckHomeownerSignatureWO();
  }

  componentWillReceiveProps(nextProps) {
    console.log(nextProps,' nextProps');
    if (AppSettings.clientTypeValue === 'Homeowner') {
      if (nextProps.RFSEndpoint !== this.props.RFSEndpoint) {
        this.setState({
          builderProfile: nextProps.RFSEndpoint
        });
      }
    }

    if (nextProps.UploadSuccess !== this.props.UploadSuccess) {
      this.setState({
        signatureStatus: nextProps.UploadSuccess
      });
    }
  }

  onChangeDate = (type, value) => {
    if (value) {
      if (Moment(value, 'MM/DD/YYYY', true).isValid()) {
        this.setState({
          [type]: value,
          error: {
            ...this.state.error,
            [type]: null
          }
        });
      } else {
        this.setState({
          error: {
            ...this.state.error,
            [type]: 'Invalid datetime.'
          }
        });
      }
    } else {
      this.setState({
        [type]: value
      });
    }
  };

  fetchRFS = () => {
    this.props.dispatch({
      type: RFSActionType.GET_GLOBAL_ENDPOINT_RFS_ASYNC,
      params: this.props.rfsId
    });
  };

  onSave = e => {
    // console.log(this.state.homeownerSignatureUrl, 'homeownerSignatureUrl');
    e.preventDefault();
    if (this.state.accepted && this.state.accepted.length) {
      const file = this.state.accepted[0];
      this.props.onUploadFileToS3(file);
    }
    const lastResolvedDate = this.props.isSignoffFromOpen
      ? formatTimezoneDateTime(this.lastResolvedDate.state.selectedDate)
      : null;
    const lastClosedDate =
      AppSettings.clientTypeValue !== 'Homeowner'
        ? formatTimezoneDateTime(this.lastClosedDate.state.selectedDate)
        : formatTimezoneDateTime(Moment());

    const homeownerSignature = this.state.homeownerSignatureUrl;
    this.props.onSaveSignoffPopup(lastResolvedDate, lastClosedDate, homeownerSignature);
  };

  onChecked = e => {
    e.preventDefault();
    this.setState({
      homeownerSignature: null,
      homeownerSignatureUrl: null,
      isChecked: !this.state.isChecked
    }, () => {
      this.props.onResetCheckUploadFile();
    });
  };

  handleDropFile = (accepted, rejected) => {
    this.setState({
      accepted,
      rejected
    });
  };

  onRemoveAttachment = () => {
    this.setState({
      accepted: null,
      rejected: null
    });
  };

  customAccordionStyle = () => {
    let attachmentHeight = 0;
    if (this.state.isChecked) {
      attachmentHeight = -25;
    }
    if (AppSettings.clientTypeValue !== 'Homeowner') {
      let style = {
        width: 400,
        left: 75,
        paddingTop: 20
      };
      if (this.props.isSignoffFromOpen) {
        if (
          this.state.error.lastClosedDate &&
          this.state.error.lastResolvedDate
        ) {
          style['top'] = -325;
        } else if (
          this.state.error.lastClosedDate ||
          this.state.error.lastResolvedDate
        ) {
          style['top'] = -300;
        } else {
          if(this.state.isChecked && this.props.checkHomeownerWO === false){
            style['top'] = -375;
          }else{
            style['top'] = -275;
          }
        }
      } else {
        if (this.state.error.lastClosedDate) {
          style['top'] = -240 + attachmentHeight;
        } else {
          style['top'] = -215 + attachmentHeight;
        }
      }
      return style;
    } else {
      return {
        width: 500,
        left: 62,
        paddingTop: 20,
        top: -172 + attachmentHeight
      };
    }
  };

  customStyle = () => {
    let attachmentHeight = 0;
    if (this.state.isChecked) {
      attachmentHeight = -25;
    }
    if (AppSettings.clientTypeValue !== 'Homeowner') {
      let style = {
        width: 500,
        left: 75,
        paddingTop: 20
      };
      if (this.props.isSignoffFromOpen) {
        if (
          this.state.error.lastClosedDate &&
          this.state.error.lastResolvedDate
        ) {
          style['top'] = -325;
        } else if (
          this.state.error.lastClosedDate ||
          this.state.error.lastResolvedDate
        ) {
          style['top'] = -300;
        } else {
          style['top'] = -275;
        }
      } else {
        if (this.state.error.lastClosedDate) {
          style['top'] = -240 + attachmentHeight;
        } else {
          style['top'] = -215 + attachmentHeight;
        }
      }
      return style;
    } else {
      return {
        width: 500,
        left: 62,
        paddingTop: 20,
        top: -172 + attachmentHeight
      };
    }
  };

  onSaveHomeownerSignature = () => {
    this.setState({
      homeownerSignature: this.homeownerSignature
        .getTrimmedCanvas()
        .toDataURL('image/png')
    }, () => this.uploadHomeownerSignatureToS3());
  }

  onClearHomeownerSignature = () => {
    this.homeownerSignature.clear();
    this.setState({
      homeownerSignature: null,
      homeownerSignatureUrl: null
    }, () => {
      this.props.onResetCheckUploadFile();
    });
  }

  uploadHomeownerSignatureToS3 = () => {
    const {builderProfile} = this.state;
    if (AppSettings.clientTypeValue === 'Builder') {
      this.props.dispatch({
        type: CommonActionType.COMMON_SETUP_AWS_ASYNC,
        params: {
          resourcePath: `/request-for-services/${this.props.rfsId}/work-order/${this.props.workOrderId}/detail/signatures`
        },
        callback: awsCredential => {
          this.awsCredential = awsCredential;
          this.props.dispatch({
            type: CommonActionType.COMMON_UPLOAD_SIGNATURE_TO_S3_ASYNC,
            paramsUpload: {
              refNo: this.props.workOrderId,
              rfsId: this.props.rfsId,
              data: this.state.homeownerSignature,
              config: {
                ...this.awsCredential,
                path: this.awsCredential.path
              }
            },
            callback: (status, callbackData) => {
              if (status === true) {
                // console.log(callbackData, 'callbackData');
                this.getHomeownerSignatureS3(callbackData);
              }
            }
          });
        }
      });
    } else if (AppSettings.clientTypeValue === 'Homeowner') {
      //API FOR HOMEOWNER
      this.props.dispatch({
        type: RFSActionType.HOMEOWNER_RFS_SETUP_AWS_ASYNC,
        params: {
          builderHost: builderProfile.builderHost,
          headers: {
            key: builderProfile.headerKey,
            value: builderProfile.securityToken
          },
          param: { resourcePath: `/request-for-services/${this.props.rfsId}/work-order/${this.props.workOrderId}/detail/signatures` }
        },
        callback: awsCredential => {
          this.awsCredential = awsCredential;
          this.props.dispatch({
            type: CommonActionType.COMMON_UPLOAD_SIGNATURE_TO_S3_ASYNC,
            paramsUpload: {
              refNo: this.props.workOrderId,
              rfsId: this.props.rfsId,
              data: this.state.homeownerSignature,
              config: {
                ...this.awsCredential,
                path: this.awsCredential.path
              }
            },
            callback: (status, callbackData) => {
              if (status === true) {
                // console.log(callbackData, 'callbackData');
                this.getHomeownerSignatureS3(callbackData);
              }
            }
          });
        }
      });
    }
    else if (AppSettings.clientTypeValue === 'Subcontractor') {
      //API FOR SUBCONTRACTOR
    }
  }

  getHomeownerSignatureS3 = (callbackData) => {
    this.setState({
      homeownerSignatureUrl: callbackData.data.Location
    }, () => {
      this.props.onCheckUploadFile();
    });
  }

  render() {
    // console.log(this.state.homeownerSignature, 'homeownerSignature');
    console.log(this.state.signatureStatus, 'upload status');
    const popupStyle = this.props.isAccordion == true ? this.customAccordionStyle() : this.customStyle();
    const uploadDisabled = this.props.isSignoffFromOpen
      ? !this.state.lastClosedDate ||
      !this.state.isChecked ||
      !this.state.lastResolvedDate || !this.state.signatureStatus ||
      this.state.error.lastResolvedDate ||
      this.state.error.lastClosedDate
      : !this.state.lastClosedDate ||
      !this.state.isChecked || !this.state.signatureStatus ||
      this.state.error.lastClosedDate;
    const disabled = this.props.isSignoffFromOpen
      ? !this.state.lastClosedDate ||
        !this.state.isChecked ||
        !this.state.lastResolvedDate ||
        this.state.error.lastResolvedDate ||
        this.state.error.lastClosedDate
      : !this.state.lastClosedDate ||
        !this.state.isChecked ||
        this.state.error.lastClosedDate;
    return (
      <Popup
        ref={ref => {
          this.resolvePopup = ref;
        }}
        className='sign-off-popup'
        isHasFaded={true}
        styles={popupStyle}
      >
        {this.props.isSignoffFromOpen && (
          <div className='form-group clearfix' style={{ marginBottom: 20 }}>
            <div className='col-sm-12 col-xs-12'>
              <span
                className='col-xs-4'
                style={{ paddingLeft: 0, color: '#444', lineHeight: '40px' }}
              >
                Last resolved
              </span>
              <div className='col-xs-8'>
                <Datetime
                  ref={ref => {
                    this.lastResolvedDate = ref;
                  }}
                  inputProps={{ placeholder: 'mm/dd/yyyy' }}
                  value={this.state.lastResolvedDate}
                  timeFormat={false}
                  onChange={lastResolvedDate =>
                    this.onChangeDate('lastResolvedDate', lastResolvedDate)
                  }
                  closeOnSelect={true}  />
                {this.state.error.lastResolvedDate && (
                  <span className='text-danger' style={{ fontSize: 12 }}>
                    {this.state.error.lastResolvedDate}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
        {AppSettings.clientTypeValue !== 'Homeowner' && (
          <div className='form-group' style={{ marginBottom: 0 }}>
            <div className='col-sm-12 col-xs-12'>
              <span
                className='col-xs-4'
                style={{ paddingLeft: 0, color: '#444', lineHeight: '40px' }}
              >
                Last closed
              </span>
              <div className='col-xs-8'>
                <Datetime
                  ref={ref => {
                    this.lastClosedDate = ref;
                  }}
                  inputProps={{ placeholder: 'mm/dd/yyyy' }}
                  value={this.state.lastClosedDate}
                  timeFormat={false}
                  onChange={lastClosedDate =>
                    this.onChangeDate('lastClosedDate', lastClosedDate)
                  }
                  closeOnSelect={true}  />
                {this.state.error.lastClosedDate && (
                  <span className='text-danger' style={{ fontSize: 12 }}>
                    {this.state.error.lastClosedDate}
                  </span>
                )}
              </div>
            </div>
          </div>
        )}
        <div className='form-group' style={{ marginBottom: 0, paddingLeft: 0 }}>
          <div className='col-sm-12 col-xs-12'>
            <CheckBoxSingle
              ref={c => {
                this.checkBox = c;
              }}
              checked={this.state.isChecked}
              onChecked={this.onChecked}
              label='I agree that the work order is resolved'
            />
          </div>
        </div>

        {/* Attachment File */}
        {/* {!this.props.isSignoffFromOpen && this.state.isChecked && (
          <div
            className='form-group'
            style={{ marginBottom: 0, paddingLeft: 0 }}
          >
            {this.state.accepted && this.state.accepted.length ? (
              <div className='col-sm-12 col-xs-12 attachment-sign-off'>
                <span>Signed document: </span>
                <span style={{ fontWeight: 600 }}>
                  {this.state.accepted[0].name}
                </span>
                <span>
                  <i
                    className='fa fa-trash-o'
                    style={{ marginLeft: 10 }}
                    onClick={this.onRemoveAttachment}
                  />
                </span>
              </div>
            ) : (
              <div className='col-sm-12 col-xs-12 attachment-sign-off'>
                <i className='fa fa-cloud-upload' />
                <Dropzone
                  accept='image/jpeg, image/png, image/gif, application/pdf'
                  style={{ display: 'inline-block' }}
                  multiple={false}
                  onDrop={(accepted, rejected) => {
                    this.handleDropFile(accepted, rejected);
                  }}
                >
                  <p style={{ margin: 0 }}>
                    <span
                      className='browse-txt'
                      style={{
                        fontSize: 13,
                        textDecoration: 'underline'
                      }}
                    >
                      Attach the signed document
                    </span>
                    <span
                      style={{ color: '#ccc', fontSize: 13, marginLeft: 10 }}
                    >
                      (optional)
                    </span>
                  </p>
                </Dropzone>
              </div>
            )}
          </div>
        )} */}

        {/* HOMEOWNER SIGNATURE INPUT */}
        {this.state.isChecked && this.props.checkHomeownerWO === false &&
        <div className='signature-upload-work-order'>
          <div className='signature-input-work-order col-sm-12 col-xs-12'>
            <label style={{ padding: 0 }}>
            Homeowner signature
            </label>
            <span
              style={{ color: '#ccc', fontSize: 13, marginLeft: 10 }}
            >
                                    (optional)
            </span>
          </div>
          <div className='col-sm-12 col-xs-12 signature-input-field'>
            <button
              style={{marginTop: 5, left: 'auto', right: 35, position: 'absolute', marginRight: -5}}
              type='button'
              className='close'
              onClick={this.onClearHomeownerSignature}
            >&times;</button>
            <SignatureCanvas
              penColor='black'
              canvasProps={{
                top: '-6px',
                bottom: '15px',
                right: '10px',
                marginLeft: -15,
                marginTop: 20,
                width: 430,
                maxwidth: 450,
                height: 150,
                border: '1px solid black'
              }}
              className='homeownerSignature'
              ref={ref => {
                this.homeownerSignature = ref;
              }}
              onEnd={this.onSaveHomeownerSignature}
            />
          </div>
        </div>}
        <ul
          className='wo-popup-bottom-btn'
          style={{ marginTop: 0, borderTop: 0 }}
        >
          <li>
            <button
              className='btn btn-primary btn-siteone-default btn-wo-edit'
              onClick={this.props.onCancelSignoffPopup}
            >
              Cancel
            </button>
          </li>
          <li>
            <button
              className='btn btn-primary btn-siteone btn-wo-close'
              onClick={this.onSave}
              disabled={this.state.homeownerSignature !== null ? uploadDisabled : disabled}
            >
              {AppSettings.clientTypeValue === 'Homeowner'
                ? 'Save & Sign off'
                : 'Save & Close'}
            </button>
          </li>
        </ul>
      </Popup>
    );
  }
}

const mapStateToProps = state => {
  return {
    RFSEndpoint: state.RFSStore.RFSEndpoint
  };
};

export default connect(mapStateToProps)(SignoffPopup);



// WEBPACK FOOTER //
// ./src/Work-Orders/Components/SignoffPopup.js